import bigpay77Logo from '../assets/logos/bigpay77.png';
import bybid9Logo from '../assets/logos/bybid9.png';
import gucci9Logo from '../assets/logos/gucci9.png';
import ipay9Logo from '../assets/logos/ipay9.png';
import ipay9vipLogo from '../assets/logos/ipay9vip.png';
import kingbet9Logo from '../assets/logos/kingbet9.png';
import me99Logo from '../assets/logos/me99.png';
import micky9Logo from '../assets/logos/micky9.png';
import mrbean9Logo from '../assets/logos/mrbean9.png';
import mrboom9Logo from '../assets/logos/mrboom9.png';
import spinarooLogo from '../assets/logos/spinaroo.png';
import queen13Logo from '../assets/logos/queen13.png';
import rolex9Logo from '../assets/logos/rolex9.png';
import winnie777Logo from '../assets/logos/winnie777.png';
import bigpay77CoverImage from '../assets/brand-covers/bigpay77-cover.png';
import bybid9CoverImage from '../assets/brand-covers/bybid9-cover.png';
import gucci9CoverImage from '../assets/brand-covers/gucci9-cover.png';
import ipay9CoverImage from '../assets/brand-covers/ipay9-cover.png';
import ipay9vipCoverImage from '../assets/brand-covers/ipay9vip-cover.png';
import kingbet9CoverImage from '../assets/brand-covers/kingbet9-cover.png';
import me99CoverImage from '../assets/brand-covers/me99-cover.png';
import micky9CoverImage from '../assets/brand-covers/micky9-cover.png';
import mrbean9CoverImage from '../assets/brand-covers/mrbean9-cover.png';
import mrboom9CoverImage from '../assets/brand-covers/mrboom9-cover.png';
import spinarooCoverImage from '../assets/brand-covers/spinaroo-cover.png';
import queen13CoverImage from '../assets/brand-covers/queen13-cover.png';
import rolex9CoverImage from '../assets/brand-covers/rolex9-cover.png';
import winnie777CoverImage from '../assets/brand-covers/winnie777-cover.png';

export const casinoData = [
  {
    id: 15,
    name: 'iPay9vip',
    slug: 'ipay9vip',
    logo: ipay9vipLogo,
    coverImage: ipay9vipCoverImage,
    loginUrl: 'https://www.ipay9aud.co/en-au/?ref=IPAY9F2952',
    registerUrl: 'https://www.ipay9aud.co/en-au/?ref=IPAY9F2952',
    infoUrl: '/brands/ipay9vip',
    description: 'iPay9vip is the exclusive VIP platform created for iPay9 VIP members, offering a more premium and rewarding experience with VIP-only promotions, selected games, special member privileges and personalised benefits. Smooth gameplay, easy navigation and trusted providers come together in one dedicated space designed specifically for valued iPay9 VIP players.'
  },
  {
    id: 14,
    name: 'MrBoom9',
    slug: 'mrboom9',
    logo: mrboom9Logo,
    coverImage: mrboom9CoverImage,
    loginUrl: 'https://mrboom9.com/RFAUSPARTNERSHIPP',
    registerUrl: 'https://mrboom9.com/RFAUSPARTNERSHIPP',
    infoUrl: '/brands/mrboom9',
    description: 'MrBoom9 is a high-reward casino platform for Australian players who want smooth gameplay and strong promotions. New users can enjoy generous registration bonuses, while active members can benefit from massive share bonus offers, monthly deposit ranking rewards, and limited-time free credit events. With stable performance on both mobile and desktop, MrBoom9 is a top entertainment choice in Australia.'
  },
  {
    id: 1,
    name: 'MrBean9',
    slug: 'mrbean9',
    logo: mrbean9Logo,
    coverImage: mrbean9CoverImage,
    loginUrl: 'https://mrbean9au.com/RFTPASSEO',
    registerUrl: 'https://mrbean9au.com/RFTPASSEO',
    infoUrl: '/brands/mrbean9',
    description: 'MrBean9 is a unique Australian online casino inspired by a playful Mr.Bean theme. Players can explore a broad mix of games with regular updates and enjoy ongoing promotions such as daily rewards, app bonuses, seasonal offers, and birthday perks. It is a lively option for users who want variety, entertainment, and frequent bonus opportunities in one place.'
  },
  {
    id: 2,
    name: 'Spinaroo',
    slug: 'spinaroo',
    logo: spinarooLogo,
    coverImage: spinarooCoverImage,
    loginUrl: 'https://spinarooaus.com/RFTPASEOO',
    registerUrl: 'https://spinarooaus.com/RFTPASEOO',
    infoUrl: '/brands/spinaroo',
    description: 'Spinaroo focuses on high RTP slot games and VIP bonus rewards for Australian players. The platform highlights competitive return-to-player slots, smooth e-wallet access, and VIP-tier benefits designed for regular players. With secure payments and strong promotional value, Spinaroo is built for users who want better slot performance and ongoing VIP perks.'
  },
  {
    id: 3,
    name: 'Gucci9',
    slug: 'gucci9',
    logo: gucci9Logo,
    coverImage: gucci9CoverImage,
    loginUrl: 'https://gucci9au.org/RFTPASEO',
    registerUrl: 'https://gucci9au.org/RFTPASEO',
    infoUrl: '/brands/gucci9',
    description: 'Gucci9 delivers a sleek and modern casino experience for players in Australia. The platform includes live dealer games, slots, lotteries, and arcade options, supported by secure payment methods and responsive access on web and app. With VIP perks and a polished interface, Gucci9 suits users who want a premium feel with reliable gameplay.'
  },
  {
    id: 4,
    name: 'iPay9',
    slug: 'ipay9',
    logo: ipay9Logo,
    coverImage: ipay9CoverImage,
    loginUrl: 'https://i9aud.net/RFTPASEO',
    registerUrl: 'https://i9aud.net/RFTPASEO',
    infoUrl: '/brands/ipay9',
    description: 'iPay9 combines a convenient e-wallet service with online gaming access for Australian users. It focuses on simple deposits, quick withdrawals, and secure account management, while also providing mobile-friendly game access for play on the go. For users who value smooth transactions and an easy all-in-one experience, iPay9 is a practical and reliable option.'
  },
  {
    id: 5,
    name: 'Me99',
    slug: 'me99',
    logo: me99Logo,
    coverImage: me99CoverImage,
    loginUrl: 'https://me99aus.net/RFTPASEEO',
    registerUrl: 'https://me99aus.net/RFTPASEEO',
    infoUrl: '/brands/me99',
    description: 'Me99 is a full-featured betting and casino platform tailored for Australian players. It offers secure wallet integration, straightforward registration, and a broad game catalog that includes slots, live casino action, and classic favorites. With regular promotions and a user-friendly flow, Me99 is designed for players who want speed, safety, and consistent value.'
  },
  {
    id: 6,
    name: 'Bybid9',
    slug: 'bybid9',
    logo: bybid9Logo,
    coverImage: bybid9CoverImage,
    loginUrl: 'https://bybid9.net/RFRFTPASEO',
    registerUrl: 'https://bybid9.net/RFRFTPASEO',
    infoUrl: '/brands/bybid9',
    description: 'Bybid9 focuses on the highest RTP slot games, instant payouts, and massive VIP rewards for Australian players. The platform is built around high-return slots, fast withdrawal flows, and VIP-tier bonuses that reward active play. With secure e-wallet support and a clear reward path, Bybid9 suits players who want strong slot value, speed, and premium VIP benefits.'
  },
  {
    id: 7,
    name: 'Rolex9',
    slug: 'rolex9',
    logo: rolex9Logo,
    coverImage: rolex9CoverImage,
    loginUrl: 'https://rolex9au.com/RFSEOTPA',
    registerUrl: 'https://rolex9au.com/RFSEOTPA',
    infoUrl: '/brands/rolex9',
    description: 'Rolex9 is a trusted online gaming platform known for accessible gameplay and regular promotions. The site covers key categories such as slots and live casino tables, with mobile support that makes it easy to play anywhere. With quick account access and secure transactions, Rolex9 is built for players who want a balanced mix of convenience and excitement.'
  },
  {
    id: 8,
    name: 'Kingbet9',
    slug: 'kingbet9',
    logo: kingbet9Logo,
    coverImage: kingbet9CoverImage,
    loginUrl: 'https://king9au.co/RFTPASEO13',
    registerUrl: 'https://king9au.co/RFTPASEO13',
    infoUrl: '/brands/kingbet9',
    description: 'Kingbet9 provides a reliable casino environment with secure wallet payments and a broad selection of slot-focused content. Its mobile-ready platform lets users register quickly, log in with ease, and access games without friction. With welcome offers and recurring promotions, Kingbet9 appeals to players looking for a smooth and dependable gaming routine.'
  },
  {
    id: 9,
    name: 'Bigpay77',
    slug: 'bigpay77',
    logo: bigpay77Logo,
    coverImage: bigpay77CoverImage,
    loginUrl: 'https://bigpay77.co/RFTPASEO',
    registerUrl: 'https://bigpay77.co/RFTPASEO',
    infoUrl: '/brands/bigpay77',
    description: 'Bigpay77 is a popular Australian gaming platform with an extensive mix of live casino titles and slot content from well-known providers. The integrated e-wallet experience helps users deposit and withdraw with minimal hassle, while new and returning players can benefit from welcome and daily promotional offers. It is a strong fit for users who value game variety, convenience, and steady rewards.'
  },
  {
    id: 10,
    name: 'Queen13',
    slug: 'queen13',
    logo: queen13Logo,
    coverImage: queen13CoverImage,
    loginUrl: 'https://queen13au.com/RFTPAASEO',
    registerUrl: 'https://queen13au.com/RFTPAASEO',
    infoUrl: '/brands/queen13',
    description: 'Queen13 positions itself as a premium-style online casino for Australian players who enjoy a more elevated brand experience. The platform offers mobile access, newcomer incentives, and slot-focused welcome benefits, alongside a large and active user community. With its polished presentation and promotional depth, Queen13 is suited to users who want both atmosphere and value.'
  },
  {
    id: 11,
    name: 'Winnie777',
    slug: 'winnie777',
    logo: winnie777Logo,
    coverImage: winnie777CoverImage,
    loginUrl: 'https://winnie777.net/RFTTPASEO',
    registerUrl: 'https://winnie777.net/RFTTPASEO',
    infoUrl: '/brands/winnie777',
    description: 'Winnie777 blends Australian-themed branding with a broad online casino lineup, from pokies-style games to table action. The platform aims to deliver a lively and welcoming experience, with simple navigation and consistent entertainment value. It is a good match for players who want a casual, fun atmosphere without sacrificing game choice.'
  },
  {
    id: 12,
    name: 'Micky9',
    slug: 'micky9',
    logo: micky9Logo,
    coverImage: micky9CoverImage,
    loginUrl: 'https://micky9.net/RFTPPASEO',
    registerUrl: 'https://micky9.net/RFTPPASEO',
    infoUrl: '/brands/micky9',
    description: 'Micky9 offers a friendly starting point for new users with low deposit thresholds and straightforward withdrawal conditions. Beyond gaming, it also highlights a referral and agent pathway for users interested in earning through community growth. This combination of accessibility and earning potential makes micky9 appealing to both casual players and active promoters.'
  }
];